// removed by extract-text-webpack-plugin
module.exports = {"component":"LRdQMuQW9HJZQnb1VNo3p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Captcha/captcha.css
// module id = 1282
// module chunks = 2